<section class="banner">

    <div class="container">
        <div class="topbar">
            <img src="assets/img/svg/logo_login.svg" alt="logo">
        </div>

        <div class="banner__parent">
            <div class="banner__left">
                <div class="top_content">
                    <h6>Looking for Financing?</h6>
                    <h1>We’ll Help You Get Matched with a provider.</h1>
                    <p>Denefits works with partnered businesses to offer flexible payment plans. Fill out a few details
                        and we'll connect you with someone near you.</p>
                </div>

                <div class="d-md-none">
                    <ng-container *ngTemplateOutlet="form"></ng-container>
                </div>

                <div class="btoom_content">
                    <h3>How it works</h3>
                    <ul>
                        <li>
                            <svg class="icon" width="44" height="44" viewBox="0 0 44 44" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect width="44" height="44" rx="22" fill="#CCE4FA" />
                                <path
                                    d="M12 15H33.6471V17.6154H12V15ZM12 20.2308H25.5294V22.8462H12V20.2308ZM12 25.4615H25.5294V28.0769H12V25.4615ZM29.5882 25.4615V21.5385L35 26.7692L29.5882 32V28.0769H24.1765V25.4615H29.5882Z"
                                    fill="#1167B6" />
                            </svg>
                            <div class="">
                                <h6>Submit Your Request</h6>
                                <p>Tell us what kind of service you’re looking for and your location.</p>
                            </div>

                        </li>

                        <li>
                            <svg class="icon" width="44" height="44" viewBox="0 0 44 44" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect width="44" height="44" rx="22" fill="#CCE4FA" />
                                <path
                                    d="M22 10C17.0243 10 13 13.756 13 18.4C13 24.7 22 34 22 34C22 34 31 24.7 31 18.4C31 13.756 26.9757 10 22 10ZM22 21.4C21.1475 21.4 20.33 21.0839 19.7272 20.5213C19.1244 19.9587 18.7857 19.1957 18.7857 18.4C18.7857 17.6044 19.1244 16.8413 19.7272 16.2787C20.33 15.7161 21.1475 15.4 22 15.4C22.8525 15.4 23.67 15.7161 24.2728 16.2787C24.8756 16.8413 25.2143 17.6044 25.2143 18.4C25.2143 19.1957 24.8756 19.9587 24.2728 20.5213C23.67 21.0839 22.8525 21.4 22 21.4Z"
                                    fill="#1167B6" />
                                <path d="M26.8889 31H33V33H26.8889V31ZM11 31H17.1111V33H11V31Z" fill="#1167B6" />
                            </svg>

                            <div class="">
                                <h6>Get Matched with a Nearby Provider</h6>
                                <p>We’ll connect you with a trusted business near you offering flexible payment options.
                                </p>
                            </div>

                        </li>

                        <li>
                            <svg class="icon" width="44" height="44" viewBox="0 0 44 44" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect width="44" height="44" rx="22" fill="#CCE4FA" />
                                <path d="M12.0124 33L38 22L12.0124 11L12 19.5556L30.5714 22L12 24.4444L12.0124 33Z"
                                    fill="#1167B6" />
                            </svg>


                            <div class="">
                                <h6>Prefer a Business? We’ll Reach Out</h6>
                                <p>Already have a business in mind? We’ll try to connect you directly with them.</p>
                            </div>

                        </li>
                    </ul>
                </div>
            </div>

            <div class="banner__right ">
                <ng-container *ngTemplateOutlet="form"></ng-container>
            </div>
        </div>



    </div>

    <div class="footer">
        <div class="container">
            <div class="footer__parent">
                <div class="footer__left">
                    <p><b>Denefits is committed to helping you find the best financial solutions. </b></p>
                    <span>
                        Let's work together to make things easier!
                    </span>
                </div>
                <div class="footer__right">
                    <a href="https://www.denefits.com/request-a-callback/" target="_blank" type="button" class="button">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15 7V7.01M18 7V7.01M21 7V7.01M5 4H9L11 9L8.5 10.5C9.57096 12.6715 11.3285 14.429 13.5 15.5L15 13L20 15V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21C14.0993 20.763 10.4202 19.1065 7.65683 16.3432C4.8935 13.5798 3.23705 9.90074 3 6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4Z"
                                stroke="#2196F3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p><b>Contact Us</b>
                            <span>We're just a phone call or email away</span>
                        </p>
                    </a>

                    <a href="https://www.denefits.com/get-in-touch/" target="_blank" type="button" class="button">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M11.9993 21.1451C17.0488 21.1451 21.1422 17.0517 21.1422 12.0022C21.1422 6.95277 17.0488 2.85938 11.9993 2.85938C6.94984 2.85938 2.85645 6.95277 2.85645 12.0022C2.85645 17.0517 6.94984 21.1451 11.9993 21.1451Z"
                                stroke="#9747FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M11.9997 16.5725C14.5244 16.5725 16.5711 14.5258 16.5711 12.0011C16.5711 9.47639 14.5244 7.42969 11.9997 7.42969C9.47492 7.42969 7.42822 9.47639 7.42822 12.0011C7.42822 14.5258 9.47492 16.5725 11.9997 16.5725Z"
                                stroke="#9747FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M15.4272 8.57589L18.2843 5.71875M15.4272 15.433L18.2843 18.2902M8.57003 15.433L5.71289 18.2902M8.57003 8.57589L5.71289 5.71875"
                                stroke="#9747FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        <p><b>Support</b>
                            <span>Our friendly team is ready to guide you</span>
                        </p>
                    </a>


                </div>
            </div>

        </div>
        <p class="copright -d-md-none">Denefits © {{currentYear}}. All rights reserved.</p>
    </div>
</section>

<ng-template #form>
    <div class="from">
        <ng-container *ngIf="!showThankyou">
            <h5>Tell Us What You Need</h5>
            <form name="loginForm" [formGroup]="user" class="m-w-520 w-100">
                <div class="form-group">
                    <div
                        [ngClass]="[ (user.controls.name.invalid && user.controls.name.touched)   ? 'custom-form  inputContainer' : 'custom-form']">
                        <input type="text" class="input_field pt-3 px-3" formControlName="name" required name="name"
                            (keypress)="mainService.handleInputSpace($event)" />
                        <label for="text" class="label-name">
                            <span class="content-name f-c-p-3">
                                Full Name*
                            </span>
                        </label>
                    </div>
                    <p class="mat-error" *ngIf=" (user.controls.name.invalid && user.controls.name.touched)">Please
                        enter a valid name</p>
                </div>

                <div class="form-group">
                    <div
                        [ngClass]="[ (user.controls.email.invalid && user.controls.email.touched)   ? 'custom-form  inputContainer' : 'custom-form']">
                        <input type="text" class="input_field pt-3 px-3" formControlName="email" required name="email"
                            (keypress)="mainService.handleInputSpace($event)" />
                        <label for="text" class="label-name">
                            <span class="content-name f-c-p-3">
                                Email Address*
                            </span>
                        </label>
                    </div>
                    <p class="mat-error" *ngIf=" (user.controls.email.invalid && user.controls.email.touched)">Please
                        enter a valid email</p>
                </div>
                <div class="form-group">
                    <div
                        [ngClass]="[(user.controls.phone.invalid && user.controls.phone.touched) ? 'custom-form inputContainer' : 'custom-form']">
                        <span *ngIf="user.value.phone !== null && user.value.phone !== ''"
                            class="pt-2 pe-1 fw-bold dollar_input"
                            style="position: absolute;left: 14px;bottom: 8px;">+1 </span>
                        <input type="text" class="input_field pt-3 pe-3"
                            [ngStyle]="{'padding-left': user.value.phone !== '' ? '40px' : '1rem' }" required
                            [mask]="mask" name="phone" formControlName="phone" id="doctor_mobile" />
                        <label for="text" class="label-name">
                            <span class="content-name f-c-p-3">
                                Phone Number*
                            </span>
                        </label>
                    </div>
                    <p class="mat-error" *ngIf=" (user.controls.phone.invalid && user.controls.phone.touched)">Please
                        enter a valid phone</p>
                </div>

                <div class="form-group">
                    <div
                        [ngClass]="[ (user.controls.service.invalid && user.controls.service.touched)   ? 'custom-form  inputContainer' : 'custom-form']">
                        <input type="text" class="input_field pt-3 px-3" formControlName="service" required
                            name="service" (keypress)="mainService.handleInputSpace($event)" />
                        <label for="text" class="label-name">
                            <span class="content-name f-c-p-3">
                                Add Service Details*
                            </span>
                        </label>
                    </div>
                    <p class="mat-error" *ngIf=" (user.controls.service.invalid && user.controls.service.touched)">
                        Please enter a valid service details</p>
                </div>

                <div class="form-group">
                    <div
                        [ngClass]="[ (user.controls.preferred_business.invalid && user.controls.preferred_business.touched)   ? 'custom-form  inputContainer' : 'custom-form']">
                        <input type="text" class="input_field pt-3 px-3" formControlName="preferred_business"
                            name="preferred_business"
                            [ngClass]="{singupModify: !user.controls.preferred_business.value}"
                            (keypress)="mainService.handleInputSpace($event)" />
                        <label for="text" class="label-name">
                            <span class="content-name f-c-p-3">
                                Any preferred Business
                            </span>
                        </label>
                    </div>
                    <p class="mat-error"
                        *ngIf=" (user.controls.preferred_business.invalid && user.controls.preferred_business.touched)">
                        Please enter a valid preferred business</p>
                </div>

                <div class="form-group">
                    <div
                        [ngClass]="[(user.controls.business_phone.invalid && user.controls.business_phone.touched) ? 'custom-form inputContainer' : 'custom-form']">
                        <span *ngIf="user.value.business_phone !== null && user.value.business_phone !== ''"
                            class="pt-2 pe-1 fw-bold dollar_input"
                            style="position: absolute;left: 14px;bottom: 8px;">+1 </span>
                        <input type="text" class="input_field pt-3 pe-3"
                            [ngStyle]="{'padding-left': user.value.business_phone !== '' ? '40px' : '1rem' }"
                            [mask]="mask" name="business_phone" formControlName="business_phone" id="doctor_mobile"
                            [ngClass]="{singupModify: !user.controls.business_phone.value}" />
                        <label for="text" class="label-name">
                            <span class="content-name f-c-p-3">
                                Business Phone
                            </span>
                        </label>
                    </div>
                    <p class="mat-error"
                        *ngIf=" (user.controls.business_phone.invalid && user.controls.business_phone.touched)">Please
                        enter a valid business phone</p>
                </div>

                <div class="form-group">
                    <div
                        [ngClass]="[ (user.controls.business_email.invalid && user.controls.business_email.touched)   ? 'custom-form  inputContainer' : 'custom-form']">
                        <input type="text" class="input_field pt-3 px-3" formControlName="business_email"
                            name="business_email" [ngClass]="{singupModify: !user.controls.business_email.value}"
                            (keypress)="mainService.handleInputSpace($event)" />
                        <label for="text" class="label-name">
                            <span class="content-name f-c-p-3">
                                Business Email
                            </span>
                        </label>
                    </div>
                    <p class="mat-error"
                        *ngIf=" (user.controls.business_email.invalid && user.controls.business_email.touched)">Please
                        enter a valid business email</p>
                </div>

                <div class="form-group mb-0">
                    <!-- [disabled]="user.invalid" -->
                    <button button-primary-auth type="submit" class="w-100" (click)="submitForm()">Submit
                        Request</button>
                </div>
            </form>
        </ng-container>

        <ng-container *ngIf="showThankyou">
            <ng-container *ngTemplateOutlet="thankyou"></ng-container>

        </ng-container>

    </div>
</ng-template>


<ng-template #thankyou>
    <div class="thankyou">
        <svg width="148" height="148" viewBox="0 0 148 148" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M55.5 74L67.8333 86.3333L92.5 61.6667M18.5 74C18.5 81.2884 19.9355 88.5054 22.7247 95.2389C25.5138 101.972 29.6019 108.091 34.7556 113.244C39.9092 118.398 46.0275 122.486 52.7611 125.275C59.4946 128.064 66.7116 129.5 74 129.5C81.2884 129.5 88.5054 128.064 95.2389 125.275C101.972 122.486 108.091 118.398 113.244 113.244C118.398 108.091 122.486 101.972 125.275 95.2389C128.064 88.5054 129.5 81.2884 129.5 74C129.5 66.7116 128.064 59.4946 125.275 52.7611C122.486 46.0275 118.398 39.9092 113.244 34.7556C108.091 29.6019 101.972 25.5138 95.2389 22.7247C88.5054 19.9356 81.2884 18.5 74 18.5C66.7116 18.5 59.4946 19.9356 52.7611 22.7247C46.0275 25.5138 39.9092 29.6019 34.7556 34.7556C29.6019 39.9092 25.5138 46.0275 22.7247 52.7611C19.9355 59.4946 18.5 66.7116 18.5 74Z"
                stroke="#18B557" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

        <h6>Thank You! Your Request Has Been Sent.</h6>
        <p>We've received your financing request. Our team will now work on matching you with a trusted provider near
            you. Someone will be in touch shortly to discuss your options.</p>

        <button  class="button" button-primary-auth (click)="closeDialog()" *ngIf="isMobileView">Back To Denefits</button>

    </div>
</ng-template>


<ng-template #myModal>
    <ng-container *ngTemplateOutlet="thankyou"></ng-container>
</ng-template>